<template>
  <span :style="{color}">
    {{formatted_value}} {{text}}
  </span>
</template>

<script>

export default {
  name: 'finColorNumber',
  props: {
    value: {
      type: Number
    },
    text: {
      type: String,
      default: ''
    },
    numberFormat: {
      type: Function,
      default: null
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    color () {
      if (this.value < this.limit) return this.$finColors.accentRed
      if (this.value > this.limit) return this.$finColors.accentGreen
      return this.$finColors.primaryDark
    },
    formatted_value () {
      return this.numberFormat ? this.numberFormat(this.value) : this.value
    }
  }

}
</script>

<style scoped>

</style>
